// extracted by mini-css-extract-plugin
module.exports = {"card":"eSim_card__qzf1o","headerInfo":"eSim_headerInfo___CG6J","header":"eSim_header__tsJVu","info":"eSim_info__A9dzO","button__root":"eSim_button__root__qKQKJ"};